import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FaqsService {
  constructor(private http: HttpClient) {}

  getFaqs() {
    return this.http.get<any>(
      `${environment.apiUrl}/api/Faq`
    );
  }
  getFaqBytdm() {
    return this.http.get<any>(
      `${environment.apiUrl}/api/faq/bytdm`
    );
  }
}
